import Chip from '@mui/material/Chip';
import React from 'react';
import { PaymentStatus } from '../../../types/payments';
import {
	PAYMENT_STATE_CHIP__DECLINED,
	PAYMENT_STATE_CHIP__DISCARDED,
	PAYMENT_STATE_CHIP__DRAFT,
	PAYMENT_STATE_CHIP__ERROR,
	PAYMENT_STATE_CHIP__POSTED,
	PAYMENT_STATE_CHIP__READY,
	PAYMENT_STATE_CHIP__RETURNED,
} from '../data/constants';

interface PaymentStateChipProps {
	state: PaymentStatus;
}

const PaymentStateChip = (props: PaymentStateChipProps) => {
	const { state } = props;
	switch (state) {
		case 'draft':
			return (
				<Chip
					label={PAYMENT_STATE_CHIP__DRAFT}
					color='neutralWarning'
					variant='filled'
					size='small'
				/>
			);
		case 'posted':
			return (
				<Chip
					label={PAYMENT_STATE_CHIP__POSTED}
					color='neutralSuccess'
					variant='filled'
					size='small'
				/>
			);
		case 'ready':
			return (
				<Chip
					label={PAYMENT_STATE_CHIP__READY}
					color='neutralInfo'
					variant='filled'
					size='small'
				/>
			);
		case 'declined':
			return (
				<Chip
					label={PAYMENT_STATE_CHIP__DECLINED}
					color='neutral'
					variant='filled'
					size='small'
				/>
			);
		case 'returned':
			return (
				<Chip
					label={PAYMENT_STATE_CHIP__RETURNED}
					color='neutral'
					variant='filled'
					size='small'
				/>
			);
		case 'discarded':
			return (
				<Chip
					label={PAYMENT_STATE_CHIP__DISCARDED}
					color='neutral'
					variant='filled'
					size='small'
				/>
			);
		default:
			return <Chip label={PAYMENT_STATE_CHIP__ERROR} color='neutralError' />;
	}
};

export default PaymentStateChip;
